import type { RootState } from '../reducers/rootReducer.ts';
import { chartScenarioProperties } from './scenarioChartSelectors.ts';
import type { ICurrentScenario, LinkedScenario } from '../models/intents/intentNodeProperties.ts';
import type { ScenarioDto } from '@/api-gen/api.schemas';

import type { EvaluationProtocolElementDto as OrvalEvaluationProtocolElementDto } from '@/api-gen/api.schemas';
import type { ScenarioPersonaDto as OrvalScenarioPersonaDto } from '@/api-gen/api.schemas';

export const scenariosSelector = (state: RootState) => state.scenarioReducer.scenarios;
// Orval-typed view over scenarios (bridge)
export const scenariosOrvalSelector = (state: RootState): ScenarioDto[] =>
  (state.scenarioReducer.scenarios as unknown) as ScenarioDto[];
export const scenariosLoading = (state: RootState) => state.scenarioReducer.scenariosLoading;
export const detailedScenarioLoading = (state: RootState) => state.scenarioReducer.detailedScenarioLoading;
export const detailedScenarioIsOpening = (state: RootState) => state.scenarioReducer.detailedScenarioIsOpening;
export const scenarioHasNotBeenModifiedSelector = (state: RootState) =>
  state.scenarioReducer.scenarioHasNotBeenModified;
export const isDetailedScenarioUpdate = (state: RootState) => state.scenarioReducer.isDetailedScenarioUpdate;
export const isDetailedScenarioUpdating = (state: RootState) => state.scenarioReducer.isDetailedScenarioUpdating;
export const isStreamingEnabledForScenario = (state: RootState) => state.scenarioReducer.isStreamingEnabledForScenario;

export const getScenarioById = (scenarioId: number) => (state: RootState): ScenarioDto =>
  state.scenarioReducer.scenarios.find((s: ScenarioDto) => s.id === scenarioId);

// Orval-typed view for a specific scenario (bridge)
export const getScenarioByIdOrval = (scenarioId: number) => (state: RootState): ScenarioDto | undefined => {
  const found = state.scenarioReducer.scenarios.find((s: ScenarioDto) => s.id === scenarioId);
  return (found as unknown) as ScenarioDto | undefined;
};

// Convenience selector that exposes evaluationProtocolElements as Orval-typed DTOs
export const getScenarioEvaluationProtocolElementsOrval = (
  scenarioId: number
) => (state: RootState): OrvalEvaluationProtocolElementDto[] => {
  const scenario = state.scenarioReducer.scenarios.find((s: ScenarioDto) => s.id === scenarioId);
  return (scenario?.evaluationProtocolElements as unknown as OrvalEvaluationProtocolElementDto[]) ?? [];
};

// Convenience selector that exposes scenarioPersonas as Orval-typed DTOs
export const getScenarioPersonasOrval = (
  scenarioId: number
) => (state: RootState): OrvalScenarioPersonaDto[] => {
  const scenario = state.scenarioReducer.scenarios.find((s: ScenarioDto) => s.id === scenarioId);
  return (scenario?.scenarioPersonas as unknown as OrvalScenarioPersonaDto[]) ?? [];
};
export const currentChartScenario = (state: RootState): ScenarioDto | undefined => {
  const chartProps = chartScenarioProperties(state);
  return state.scenarioReducer.scenarios.find((s) => s.id === chartProps.id);
};
export const currentChartScenarioLang = (state: RootState): string | undefined => {
  const currentScenario = currentChartScenario(state);
  return currentScenario?.langCode;
};
export const rootScenario = (state: RootState): ScenarioDto | undefined => {
  return state.scenarioReducer.rootScenario;
};
export const parentScenario = (state: RootState): Array<LinkedScenario> | undefined => {
  return state.scenarioReducer.parentScenario;
};
export const currentScenario = (state: RootState): ICurrentScenario | undefined => {
  return state.scenarioReducer.currentScenario;
};
export const linkedScenarios = (state: RootState): Array<LinkedScenario> => {
  return state.scenarioReducer.linkedScenarios;
};

export const currentTabSelected = (state: RootState): number => {
  return state.scenarioReducer.currentTabSelected;
};
export const toNextLinkedScenario = (state: RootState): boolean => {
  return state.scenarioReducer.toNextlinkedScenario;
};
export const userSaysPhrasesByScenarioId = (state: RootState) => state.scenarioReducer.userSaysPhrasesByScenarioId;
